import { useEffect, useState } from 'react';

const MAX_RECENT_PRODUCTS = 6;

export const useRecentlyViewed = () => {
    const [recentlyViewed, setRecentlyViewed] = useState([]);

    // Load from localStorage on mount
    useEffect(() => {
        const stored = localStorage.getItem('recentlyViewed');
        if (stored) {
            try {
                setRecentlyViewed(JSON.parse(stored));
            } catch (error) {
                console.error('Failed to parse recently viewed:', error);
                localStorage.removeItem('recentlyViewed');
            }
        }
    }, []);

    // Add a product to recently viewed
    const addToRecentlyViewed = (product) => {
        if (!product || !product._id) return;

        setRecentlyViewed(prev => {
            // Remove if already exists
            const filtered = prev.filter(p => p._id !== product._id);

            // Add to front
            const updated = [product, ...filtered];

            // Keep only MAX_RECENT_PRODUCTS
            const trimmed = updated.slice(0, MAX_RECENT_PRODUCTS);

            // Save to localStorage
            localStorage.setItem('recentlyViewed', JSON.stringify(trimmed));

            return trimmed;
        });
    };

    // Clear all recently viewed
    const clearRecentlyViewed = () => {
        setRecentlyViewed([]);
        localStorage.removeItem('recentlyViewed');
    };

    // Get recently viewed excluding a specific product
    const getRecentlyViewedExcluding = (excludeId) => {
        return recentlyViewed.filter(p => p._id !== excludeId);
    };

    return {
        recentlyViewed,
        addToRecentlyViewed,
        clearRecentlyViewed,
        getRecentlyViewedExcluding,
    };
};